const veiligheidsdienstenConfig = {
  meta: {
    title: "Voorbereiding Politie, Brandweer & KMar | Mission Movement",
    description:
      "Alles over voorbereiding richting Politie, Brandweer en Koninklijke Marechaussee: selectie, fysieke keuring, opleiding, belastbaarheid, mentale weerbaarheid en gerichte training via Mission Movement.",
    ogTitle: "Voorbereiding Politie, Brandweer & KMar | Mission Movement",
    ogDescription:
      "Alles over voorbereiding richting Politie, Brandweer en Koninklijke Marechaussee: selectie, fysieke keuring, opleiding, belastbaarheid, mentale weerbaarheid en gerichte training via Mission Movement.",
    ogImage: "https://missionmovement.nl/img/thestory.png",
    ogUrl: "https://missionmovement.nl/units/veiligheidsdiensten",
    canonical: "https://missionmovement.nl/units/veiligheidsdiensten",
  },
  hero: {
    eyebrow: "Veiligheidsdiensten",
    title: "VEILIGHEIDSDIENSTEN",
    subtitle:
      "Voor kandidaten richting Politie, Brandweer en Koninklijke Marechaussee: routes, fysieke voorbereiding, selectie, keuring en opleiding.",
    imageSrc: "/img/eenheden/veiligheidsdiensten.jpg",
    imageAlt: "Veiligheidsdiensten",
  },
  intro: {
    emblemSrc: "/img/eenheden/veiligheidsdiensten-3.svg",
    emblemAlt: "Veiligheidsdiensten embleem",
    heading: "Wat zijn veiligheidsdiensten?",
    body:
      "Onder veiligheidsdiensten vallen functies waarbij je dagelijks werkt aan orde, veiligheid en hulpverlening, vaak onder druk, met duidelijke standaarden, selectieprocedures en stevige opleidingen. Deze pagina is er voor jou als je serieus wilt instromen bij de Politie, de Koninklijke Marechaussee of de Brandweer.\n\nJe krijgt per onderdeel een helder overzicht van instroomroutes, rollen en doorgroeimogelijkheden. Daarnaast wordt duidelijk waar je in je voorbereiding prioriteit aan moet geven: conditie, kracht, belastbaarheid, herstel, mentale weerbaarheid en structuur.\n\nIedere richting vraagt een andere combinatie van kracht, conditie, belastbaarheid, herstel en mentale weerbaarheid. Daarom werk je binnen Mission Movement vanuit een duidelijke structuur, met accenten die passen bij jouw doel. Je traint niet alleen voor de test. Je bouwt aan het lichaam dat de opleiding, functie-eisen en het werk daarna moet kunnen dragen.",
  },
  sections: [
    {
      title: "Politie",
      logo: "/img/eenheden/politie-7.svg",
      intro:
        "Voor wie serieus richting Politie wil: instroomroutes, mogelijke rollen en waar je in je voorbereiding prioriteit aan moet geven: conditie, kracht, stressbestendigheid, mentale weerbaarheid en duurzame belastbaarheid.",
      instroom: [
        "MBO-route (Politieagent): praktijkgerichte instroom richting basispolitiezorg",
        "HBO/WO instroom: Politiebachelor (richting o.a. Rechercheur / Wijkagent / Politieagent / Politieleider)",
        "Zij-instroom / specialistische instroom (afhankelijk van profiel en mogelijkheden)",
      ],
      rollen: [
        "Basispolitiezorg: noodhulp & wijkagent (fundament voor je eerste jaren)",
        "Opsporing: recherche (incl. specialistische opsporing)",
        "ME (Mobiele Eenheid)",
        "Verkeer (o.a. motor/handhaving verkeer)",
        "Hondengeleider",
        "Arrestatieteam / DSI-richting (sterk selectief, meestal pas na opbouw/ervaring)",
      ],
      helpt: [
        "Keuring-ready: conditie, kracht en belastbaarheid opbouwen (zonder blessure-ruis)",
        "Structuur in leefstijl: slaap, voeding, routine en herstel, zodat je dit volhoudt",
        "Dagelijkse begeleiding via chatkanaal: bijsturen, vragen, accountability",
        "Mentale weerbaarheid trainen: omgaan met stress, druk en onregelmatigheid",
      ],
    },
    {
      title: "Brandweer",
      logo: "/img/eenheden/brandweer-1.svg",
      intro:
        "Voor wie richting Brandweer wil: instroommogelijkheden, doorgroei en specialistische rollen, plus hoe je fysiek en mentaal voorbereid start op selectie, keuring, opleiding en het werk zelf.",
      instroom: [
        "Vrijwilliger: selectie en basisopleiding naast werk/leven",
        "Beroeps: zwaarder traject met selectie, keuring en opleiding (via veiligheidsregio)",
        "Doorstroom: groeien via ervaring, opleidingen en specialismen",
      ],
      rollen: [
        "Manschap → Bevelvoerder (klassieke doorgroei)",
        "Specialismen: duiker (waterongevallen / inzet onder water)",
        "Specialismen: bediener hoogwerker / redvoertuig",
        "Specialismen: verkenner / (advies) gevaarlijke stoffen (incidenten met chemie/rook/lekken)",
        "Richtingen: preventie / inspectie (afhankelijk van regio/organisatie)",
      ],
      helpt: [
        "Keuring-ready: kracht, grip, work capacity en uithoudingsvermogen opbouwen",
        "Praktische opbouw: trainen richting ‘werk-eisen’ (tillen, dragen, trapwerk, tempo onder stress)",
        "Dagelijkse begeleiding via chatkanaal: ritme, feedback en consistentie",
        "Herstel & belastbaarheid: mobiliteit, load-management en slimme progressie",
      ],
    },
    {
      title: "Koninklijke Marechaussee",
      logo: "/img/eenheden/Kmar-2.svg",
      // Fix voor optisch “klein” logo door whitespace in SVG
      logoClassName: "scale-150 md:scale-[1.7]",
      intro:
        "Voor wie richting KMar wil: routes en rollen binnen grenspolitietaken, bewaken & beveiligen en opsporing, met een realistisch beeld van wat opleiding, militaire basis en het werk fysiek en mentaal vragen.",
      instroom: [
        "Marechaussee (militair): instroom via Defensie-opleiding/vacature",
        "Marechaussee Beveiliger: aparte instroom/opleiding binnen KMar",
        "Herintreder (als je eerder hebt gediend of terugkeert binnen Defensie/KMar)",
      ],
      rollen: [
        "Grenspolitietaak & toezicht (o.a. grenspassages/luchthavens)",
        "Bewaken & beveiligen (objecten, personen, transporten – afhankelijk van inzet)",
        "Opsporingstaken (binnen het KMar-domein)",
        "BSB (Brigade Speciale Beveiligingsopdrachten) als mogelijke richting (selectief, na opbouw/ervaring)",
      ],
      helpt: [
        "Keuring-ready: kracht/conditie op defensie-niveau brengen met slimme opbouw",
        "Duurzaam trainen: mobiliteit, herstel en belastbaarheid als vaste pijlers",
        "Dagelijkse begeleiding via chatkanaal: korte lijnen, bijsturen, consistentie",
        "Belastbaarheid & discipline: routine bouwen die matcht met het leven dat je ambieert",
      ],
    },
  ],
  cta: {
    heading: "Plan je eerste contact",
    body:
      "We bespreken je doel, je startniveau en wat er nodig is om gericht te trainen richting jouw selectie, keuring of opleiding.",
    disclaimer:
      "Mission Movement is een onafhankelijke coachingdienst en niet verbonden aan Defensie, Politie, Brandweer of Koninklijke Marechaussee.",
    buttonText: "Plan eerste contact",
    buttonLink: "/contact#contact-form",
  },
  faq: {
    heading: "Veelgestelde vragen",
    items: [
      {
        title:
          "Hoe bereid ik me voor op de fysieke keuring van politie, brandweer of KMar?",
        content:
          "Begin met een brede fysieke basis: conditie, kracht, mobiliteit, herstel en belastbaarheid. De exacte eisen verschillen per dienst en functie, maar een gestructureerde voorbereiding helpt je stap voor stap sterker richting selectie, keuring en opleiding te gaan.",
      },
      {
        title: "Is voorbereiding voor politie, brandweer en KMar hetzelfde?",
        content:
          "De basis overlapt: conditie, kracht, discipline, herstel en mentale weerbaarheid. Toch vraagt elke richting iets anders. Politie vraagt veel stressbestendigheid en algemene fitheid, brandweer vraagt kracht en work capacity, en KMar combineert veiligheidswerk met militaire structuur en belastbaarheid.",
      },
      {
        title: "Kan ik dit combineren met werk of school?",
        content:
          "Ja, maar het vraagt planning en consistentie. De voorbereiding kan worden opgebouwd rond je weekindeling, zolang je structureel blijft trainen en voldoende aandacht houdt voor herstel, slaap en voeding.",
      },
      {
        title: "Heb ik al een hoog niveau nodig om te starten?",
        content:
          "Nee. Je hoeft niet perfect voorbereid te zijn om te beginnen. Het belangrijkste is dat je eerlijk weet waar je nu staat en gericht gaat bouwen aan wat ontbreekt. Een duidelijke structuur helpt je betere keuzes maken in training, herstel en opbouw. Twijfel je over pijnsignalen, eerdere blessures of belastbaarheid? Benoem dit tijdens de intake, zodat de opbouw daarop kan worden afgestemd.",
      },
      {
        title:
          "Is Mission Movement verbonden aan Politie, Brandweer, KMar of Defensie?",
        content:
          "Nee. Mission Movement is een onafhankelijke coachingdienst. We helpen kandidaten met fysieke en mentale voorbereiding, maar zijn niet verbonden aan Politie, Brandweer, Koninklijke Marechaussee of Defensie.",
      },
    ],
  },
};

export default veiligheidsdienstenConfig;
